module.exports = __webpack_public_path__ + "img/any-journey.622c8e60.png";